import PlusIcon from 'common/assets/images/icon-library/plus-icon.svg?react'
import EditIcon from 'common/assets/images/icon-library/edit-icon.svg?react'
import TrashIcon from 'common/assets/images/icon-library/trash-icon.svg?react'
import CloseIcon from 'common/assets/images/icon-library/close-icon.svg?react'
import CheckCircleIcon from 'common/assets/images/icon-library/check-circle-icon.svg?react'
import SearchIcon from 'common/assets/images/icon-library/search-icon.svg?react'
import HouseIcon from 'common/assets/images/icon-library/house-icon.svg?react'
import ChevronDownIcon from 'common/assets/images/icon-library/chevron-down.svg?react'
import RetryIcon from 'common/assets/images/icon-library/retry-icon.svg?react'
import ElipseIcon from 'common/assets/images/icon-library/elipse.svg?react'
import ElipseFilledIcon from 'common/assets/images/icon-library/elipse-filled.svg?react'
import TruckIcon from 'common/assets/images/icon-library/truck.svg?react'
import CheckIcon from 'common/assets/images/icon-library/check.svg?react'
import PhoneIcon from 'common/assets/images/icon-library/phone.svg?react'
import PackageIcon from 'common/assets/images/icon-library/package.svg?react'
import OrganisationIcon from 'common/assets/images/icon-library/organisation.svg?react'
import HubInventoryIcon from 'common/assets/images/icon-library/hub-inventory.svg?react'
import DangerIcon from 'common/assets/images/icon-library/danger.svg?react'
import WarningIcon from 'common/assets/images/icon-library/warning.svg?react'
import SuccessIcon from 'common/assets/images/icon-library/success.svg?react'
import InfoCircleIcon from 'common/assets/images/icon-library/info-circle.svg?react'
import ArrowRightIcon from 'common/assets/images/icon-library/arrow-right.svg?react'
import SubtractIcon from 'common/assets/images/icon-library/subtract.svg?react'
import SwapIcon from 'common/assets/images/icon-library/swap-icon.svg?react'
import PaletteIcon from 'common/assets/images/icon-library/palette.svg?react'
import ViewIcon from 'common/assets/images/icon-library/view.svg?react'
import HideIcon from 'common/assets/images/icon-library/hide.svg?react'
import CaretDownIcon from 'common/assets/images/icon-library/caret-down.svg?react'
import UserIcon from 'common/assets/images/icon-library/user.svg?react'
import LogoutIcon from 'common/assets/images/icon-library/logout.svg?react'
import BarcodeIcon from 'common/assets/images/icon-library/barcode-icon.svg?react'
import EmptyResultIcon from 'common/assets/images/icon-library/empty-result-icon.svg?react'
import NotDoneIcon from 'common/assets/images/icon-library/not-done-icon.svg?react'
import SunIcon from 'common/assets/images/icon-library/sun-icon.svg?react'
import MoonIcon from 'common/assets/images/icon-library/moon-icon.svg?react'
import SpinningLoaderIcon from 'common/assets/images/icon-library/spinning-loader-icon.svg?react'
import AllShipmentsIcon from 'common/assets/images/empty/all-shipments.svg?react'
import MerchantInviteImage from 'common/assets/images/empty/merchant-invite.svg?react'
import RulerDimensionLineIcon from 'common/assets/images/icon-library/ruler-dimension-line.svg?react'
import TargetIcon from 'common/assets/images/icon-library/target.svg?react'
import SubcoIcon from 'common/assets/images/icon-library/subco.svg?react'

export const IconLibrary = {
  barcode: BarcodeIcon,
  allShipments: AllShipmentsIcon,
  plus: PlusIcon,
  edit: EditIcon,
  trash: TrashIcon,
  swap: SwapIcon,
  close: CloseIcon,
  'check-circle': CheckCircleIcon,
  'info-circle': InfoCircleIcon,
  warning: WarningIcon,
  danger: DangerIcon,
  success: SuccessIcon,
  search: SearchIcon,
  phone: PhoneIcon,
  house: HouseIcon,
  'chevron-down': ChevronDownIcon,
  retry: RetryIcon,
  elipse: ElipseIcon,
  'elipse-filled': ElipseFilledIcon,
  truck: TruckIcon,
  check: CheckIcon,
  package: PackageIcon,
  organisation: OrganisationIcon,
  'hub-inventory': HubInventoryIcon,
  'arrow-right': ArrowRightIcon,
  subtract: SubtractIcon,
  palette: PaletteIcon,
  view: ViewIcon,
  hide: HideIcon,
  'caret-down': CaretDownIcon,
  user: UserIcon,
  logout: LogoutIcon,
  'empty-result': EmptyResultIcon,
  'not-done': NotDoneIcon,
  sun: SunIcon,
  moon: MoonIcon,
  'spin-loader': SpinningLoaderIcon,
  'merchant-invite': MerchantInviteImage,
  'ruler-dimension-line': RulerDimensionLineIcon,
  target: TargetIcon,
  subco: SubcoIcon,
}
